import { render } from "./ErrorView.vue?vue&type=template&id=06c6f59a"
import script from "./ErrorView.vue?vue&type=script&lang=js"
export * from "./ErrorView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apiffare/projects/norbert-weston/norbert-weston-1/apps/norbert-weston-flirter/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__